.advertFooter {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;

  > * {
    margin: 2rem 0 !important;
  }
};
